<template>
    <BodyContainerCenter>
        <template #left>
            <LayoutSidebarLeft />
        </template>
        <template #center>
            <div class="container">
                <div class="row pr-bg-white pr-shadow-sm pr--breadcrumb-main mb-3">
                    <div class="col-12">
                        <div class="d-flex align-items-center justify-content-between pr--breadcrumb-container p-0">
                            <BaseBreadcrumbs />
                        </div>
                    </div>
                </div>

                <div v-if="show.pending" class="row">
                    <div class="pr--preloader __animated">
                        <div class="--icon" />
                        <div class="--text">
                            Идет загрузка ...
                        </div>
                    </div>
                </div>
                <div v-if="!show.pending" class="row">
                    <div class="col-12">
                        <FrontendArticleDetails :article="show.data" />
                    </div>
                </div>
            </div>
        </template>
        <template #right>
            <LayoutSidebarRightArticle :article="show.data" />
        </template>
    </BodyContainerCenter>
</template>

<script setup lang="ts">
import { useAsyncData, useFetch } from 'nuxt/app';
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import BaseBreadcrumbs from '@/components/Base/Breadcrumbs/BaseBreadcrumbs.vue';
import BodyContainerCenter from '@/components/Body/BodyContainerCenter.vue';
import FrontendArticleDetails from '@/components/Frontend/Article/FrontendArticleDetails.vue';
import LayoutSidebarLeft from '@/components/Layout/Sidebar/LayoutSidebarLeft.vue';
import LayoutSidebarRightArticle from '@/components/Layout/Sidebar/LayoutSidebarRightArticle.vue';
import useResponsible from '@/hooks/responsible';
import useSeo from '@/hooks/useSeo';
import useAppConfigStore from '@/composables/useAppConfigStore';
import { useStoreAppBreadcrumbsIndex } from '@/stores/app/breadcrumbs';
import { useStoreArticlesShow } from '@/stores/articles/show';
import { useStoreSystem } from '@/stores/system';
import { definePageMeta, useServerSeoMeta } from '#imports';

//
const show = useStoreArticlesShow();
// const show = useStoreSystem();

const responsible = useResponsible();
const route = useRoute();

definePageMeta({
    layout: 'article',
    middleware: [
        'data',
    ],
});
if (useAppConfigStore().canAsyncDataLoaded(!show.loaded)) {
    await useAsyncData('article', async () => await useStoreArticlesShow().fetchShow({
        id: route.params.id,
        token: route.query.token,
    }, (data: any) => {
        if (process.client) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }));
}
if (!process.client && show.loaded) {
    useHead(useSeo().article(show.data));
    useStoreAppBreadcrumbsIndex().createArticle(show.data, show.data.group);
}
if (useStoreSystem().route.changed && show.loaded) {
    useHead(useSeo().article(show.data));
    useStoreAppBreadcrumbsIndex().createArticle(show.data, show.data.group);
}

</script>
